import React from 'react'
import PropTypes from 'prop-types'
import Validator from 'validatorjs'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'

import TextArea from 'components/TextArea'
import Input from 'components/Input'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'
import { notificationsFetched } from 'scenes/ClientDetail/actions'

export class NotificationModal extends BaseComponent {
  static validationRules = {
    title: 'string|required|min:2',
    content: 'string|required|min:5',
  }
  static validationRulesSMS = {
    title: 'string|required|min:2',
    content: 'string|required|min:5',
    sms_content: 'string|required|min:5',
  }

  constructor() {
    super()

    this.state = {
      buttonProps: {
        disabled: true
      },
      formData: {
        title: '',
        content: '',
        sms_content: ''
      },
      notifications_list: []
    }

    this._bind('_handleSubmit', '_handleChange', '_validate', '_renderSMSField')
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.context.toggleModal(false)
    this.props._onAccept(this.state.formData.title, this.state.formData.content)
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    const formData = {
      ...this.state.formData,
      [name]: value
    }
    /*var rules = this.props.claim.sms_enabled ? NotificationModal.validationRulesSMS : NotificationModal.validationRules*/
    var rules = NotificationModal.validationRules
    const validator = new Validator(formData, rules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  _renderSMSField() {
    var title = "SMS   " + this.state.formData['sms_content'].length + " / 160"
    return (this.props.claim.sms_enabled) ? (
      <span>
        <br></br>
        <Input  label={title}
          name="sms_content"
          placeholder="Texto SMS"
          value={this.state.formData.sms_content}
          onChange={this._handleChange} />
      </span>
    ): null
  }

  render() {
    return (
      <div id="NewNotification" className="NewNotification Modal__content">
        <div className="NewNotification__header d-flex justify-content-between align-items-center">
          <h1>Crear notificación</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex NewNotification__form">
          <p className="instructions">Cuando creas una notificación, la recibe el usuario en su celular.</p>
          <Input  label="Titulo"
                  name="title"
                  placeholder="Título de la notificación"
                  value={this.state.formData.title}
                  onChange={this._handleChange} />

          <TextArea placeholder="Ej: Tu coche ha salido del taller"
                    label="Mensaje:"
                    name="content"
                    value={this.state.formData.content}
                    onChange={this._handleChange} />

          {/*{this._renderSMSField()}*/}

          <div className="controls">
            <Button buttonType="primary" size="big" {...this.state.buttonProps}>Crear notificación</Button>
          </div>
        </form>
      </div>
    )
  }
}

NotificationModal.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    notification_list: state.notification_list
  }
}

const mapDispatchToProps = (dispatch) => {

  return {
    notificationsFetched: (notifications_list) => dispatch(notificationsFetched(notifications_list)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationModal)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/NotificationModal/index.js